import React from 'react'
import { Skeleton, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { formatDuration, formatNumber } from '../constants'
import { CARD_SX, PALETTE } from '../styles'

export type KeyFigureUnit = 'number' | 'duration'

type KeyFigureCardProps = {
  label: string
  value?: number | null
  unit?: KeyFigureUnit
  loading: boolean
}

const VALUE_FORMATTERS: Record<KeyFigureUnit, (value: number, language: string) => string> = {
  number: formatNumber,
  duration: formatDuration,
}

const KeyFigureCard: React.FC<KeyFigureCardProps> = ({ label, value, unit = 'number', loading }) => {
  const { i18n } = useTranslation()

  if (loading) {
    return (
      <Skeleton
        variant="rounded"
        animation="pulse"
        aria-busy="true"
        sx={{ height: 64, borderRadius: '16px', border: `1px solid ${PALETTE.border}`, bgcolor: PALETTE.tile }}
      />
    )
  }

  const formattedValue = value === null || value === undefined ? '—' : VALUE_FORMATTERS[unit](value, i18n.language)

  return (
    <Stack component="article" aria-label={label} sx={{ ...CARD_SX, gap: 0.5 }}>
      <Typography
        sx={{ fontSize: 10, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.025em', color: PALETTE.muted }}
      >
        {label}
      </Typography>
      <Typography sx={{ fontSize: 20, fontWeight: 600, color: PALETTE.text }}>{formattedValue}</Typography>
    </Stack>
  )
}

export default KeyFigureCard
